<template lang="pug">
.view-platforms.content
  ui-navbar-panel(title="Статистика серверов")
  //.container.mt-30: .columns
  //  .column
  //    .panel
  //      .panel-heading
  //        b-icon.mr-10(icon="server")
  //        span SRV-1 (VScale)
  //      .panel-block
  //        .control: b-progress(:value="diskStat.used ? diskStat.used : undefined" type="is-info" size="is-large" :show-value="!!diskStat.used")
  //          | HDD: {{ diskStat.used }}% (free: {{diskStat.avail}})
  //      //- .panel-block
  //      b-table(v-if="filesStat.length" :data="filesStat" default-sort="size_k" default-sort-direction="desc")
  //        b-table-column(field="client", label="Папка", nowrap, sortable, v-slot="{row}") {{ row.client }}
  //        b-table-column(field="size_k", label="Размер", nowrap, sortable, numeric, v-slot="{row}") {{ row.size }}
  //        b-table-column(field="percents", label="%", nowrap, sortable, numeric, v-slot="{row}") {{ row.percents }}%
  //      //- b-table-column(field="infoUsersOnline", label="Онлайн ", width="1", nowrap, sortable, numeric v-slot="{row}")
  //    //- b-button(@click="pullServerStat" icon-left="reload")
  //  .column

</template>

<script>
import api from '@/api';

export default {
  name: 'view-stat-servers',

  data: () => ({
    diskStat: {},
    filesStat: [],
  }),

  methods: {
    pullServerStat() {
      api
        .for('platforms')
        .request('get', 'pullServerStat')
        .then(data => {
          this.diskStat = data.disk_stat;
          this.diskStat.used = parseFloat(this.diskStat.used);
          this.filesStat = data.files_stat.filter(({ size_k }) => size_k > 1024 * 100); // > 100M
        });
    },
  },

  created() {
    // this.pullServerStat();
  },
};
</script>
